import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import Button from "@mui/material/Button";
import {
  changeFieldDefinitionProp,
  changeLayoutElementProp,
  changeLayoutExpressionAtLine,
  changeSchemaExpressionAtLine,
} from "developer/edit/store/editorSlice";
import { EditorVariant } from "developer/edit/types";
import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "store/hooks";

const ConfirmButton = () => {
  const dispatch = useAppDispatch();

  const {
    isValid,
    editedExpression,
    targetEditor,
    targetExpressionProp,
    targetExpressionLine,
  } = useAppSelector((state) => state.developer.edit.expressionEditor);

  const handleConfirm = useCallback(() => {
    if (targetExpressionProp) {
      if (targetEditor === EditorVariant.Layout) {
        dispatch(
          changeLayoutElementProp({
            targetProp: targetExpressionProp,
            value: editedExpression,
          })
        );
      }
      if (targetEditor === EditorVariant.Schema) {
        dispatch(
          changeFieldDefinitionProp({
            targetProp: targetExpressionProp,
            value: editedExpression,
          })
        );
      }
    } else if (targetExpressionLine) {
      if (targetEditor === EditorVariant.Layout) {
        dispatch(
          changeLayoutExpressionAtLine({
            value: editedExpression,
            targetExpressionLine,
          })
        );
      } else if (targetEditor === EditorVariant.Schema) {
        dispatch(
          changeSchemaExpressionAtLine({
            value: editedExpression,
            targetExpressionLine,
          })
        );
      }
    }
  }, [
    dispatch,
    editedExpression,
    targetEditor,
    targetExpressionLine,
    targetExpressionProp,
  ]);

  return (
    <Button
      disabled={!isValid}
      onClick={handleConfirm}
      variant="contained"
      disableElevation
      size="large"
      startIcon={<SaveOutlinedIcon />}
    >
      Confirm
    </Button>
  );
};

export default ConfirmButton;
